/** @format */

import { request } from '@/utils/request';

// 修改模板
export function editTemplate(data) {
	return request(
		{
			url: `powerportal/v1/template`,
			type: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getBookList(data) {
	return request({
		url: `/power-factory/data-processing/list`,
		type: 'post',
		data,
	});
}

// 删除模板
export function removeTemplate(jobId) {
	return request(
		{
			url: `powerportal/v1/template/${jobId}`,
			type: 'delete',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询模板详细信息
export function getTemplateInfo(roleId) {
	return request(
		{
			url: `powerportal/v1/template/${roleId}`,
			type: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 添加用户模板
export function userAddTemplate(data) {
	return request(
		{
			url: `powerportal/v1/template/userAdd`,
			type: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 添加模板
export function addTemplate(data) {
	return request(
		{
			url: `powerportal/v1/template`,
			type: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询工作台设置中模板列表
export function templateList(query) {
	return request({
		url: `powerportal/v1/template/list`,
		type: 'get',
		params: query,
	});
}

// 工单列表查询(个人待办)
export function userTodo(query) {
	return request(
		{
			url: `powerprocess/ticket/list/user/todo`,
			type: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 工单列表查询(个人已办)
export function userProcessed(query) {
	return request(
		{
			url: `powerprocess/ticket/list/user/processed`,
			type: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 工单列表查询(个人创建)
export function userCreated(query) {
	return request(
		{
			url: `powerprocess/ticket/list/user/created`,
			type: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 工单列表查询(按工单类型)
export function listModelName(query) {
	return request(
		{
			url: `powerprocess/ticket/list`,
			type: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询工单列表分类
export function workflowTypes(params) {
	return request(
		{
			url: `powerprocess/v1/config/model/brief`,
			type: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 打开工单详情
export async function openTicketInfo(query) {
	const { ticketId, modelCode } = query;
	const url = `powerprocess/dealOrder/${modelCode}/${ticketId}`;
	return {
		data: url,
	};
}

// 通过日期查询工单
export function getCalendarList(query) {
	return request(
		{
			url: `powerprocess/v1/ticket/calendar/facade`,
			type: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询工作台公告接口
export function getnoticeall(query) {
	return request(
		{
			url: '/base/notice/page',
			type: 'post',
			data: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getProcessedDraft(params) {
	return request(
		{
			url: `powerprocess/ticket/list/user/draft`,
			type: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
export function getTreeList(data) {
	return request({
		url: `powerprocess/v1/serviceType/listTreeContainServiceData`,
		type: 'post',
		data,
	});
}
